import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <img src="https://openclaw.cc/lobster.svg" alt="OpenClaw" className="w-8 h-8" />
              <span className="text-xl font-bold text-white">OpenClaw<span className="text-cyan-400">中文站</span></span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4 sm:mb-6">
              真正能做事的 AI 智能体框架，支持多消息渠道接入，打造您的专属 AI 助手平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="https://github.com/openclaw/openclaw" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-wechat-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-discord-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* 快速导航 */}
          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-sm">快速导航</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><Link to="/quick-start" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">快速开始</Link></li>
              <li><Link to="/installation" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">安装指南</Link></li>
              <li><Link to="/channels" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">消息渠道</Link></li>
              <li><Link to="/agents" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">智能体</Link></li>
              <li><Link to="/tools" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">工具</Link></li>
            </ul>
          </div>

          {/* 核心功能 */}
          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-sm">核心功能</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><Link to="/models" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">AI 模型</Link></li>
              <li><Link to="/platform" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">平台部署</Link></li>
              <li><Link to="/gateway" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">API 网关</Link></li>
              <li><Link to="/reference" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">API 参考</Link></li>
              <li><Link to="/help" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">帮助中心</Link></li>
            </ul>
          </div>

          {/* 社区资源 */}
          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-sm">社区资源</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="https://github.com/openclaw/openclaw" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">GitHub 仓库</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">问题反馈</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">贡献指南</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">更新日志</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">社区论坛</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 OpenClaw 中文站. MIT License.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}